// extracted by mini-css-extract-plugin
export default {"watermarkingEmptyState":"euuHfEa3g8s8Gb9u2Wy5","watermarkingEmptyStateSvg":"qd5v99q2bwSwrIsXkY3M","watermarkingEmptyStateDescription":"V6tQrz4Ko3kT3z8ICcJK"};